<template>
    <b-row>
        <b-col cols="12">
            <h4>개선계획 관리: {{ actionplan_company.company_name }}</h4>
        </b-col>
        <b-col cols="12" class="mb-4">
            <b-card :header="`${actionplan_company.company_name} - 평가 정보`" header-class="h5" no-body>
                <b-table-simple bordered class="bg-white mb-0">
                    <b-thead>
                        <b-tr>
                            <b-th>프로젝트 코드</b-th>
                            <b-th>캠페인</b-th>
                            <b-th>회사명</b-th>
                            <b-th>평가 상태</b-th>
                            <b-th>평가 유형</b-th>
                            <b-th>평가 신청자</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr>
                            <b-td>{{ actionplan_company.project_code }}</b-td>
                            <b-td>
                                {{ actionplan_company.campaign_name }}
                                <b-badge>{{ actionplan_company.campaign_id }}</b-badge>
                            </b-td>
                            <b-td>
                                {{ actionplan_company.company_name }}
                                <b-badge>{{ actionplan_company.company_id }}</b-badge>
                            </b-td>
                            <b-td>
                                {{ statsLabel_eng[actionplan_company.status_code] }}
                            </b-td>
                            <b-td>{{ actionplan_company.service_type }}</b-td>
                            <b-td>{{ actionplan_company.requested_e_mail }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>
        </b-col>
        <b-col cols="12">
            <b-row>
                <b-col v-if="actionplan_company.action_plan.length > 0" cols="12">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                        <b-form-select v-model="selectedActionPlanIndex"
                                       style="width: 220px"
                                       class="mr-3"
                        >
                            <b-form-select-option v-if="selectedActionPlanIndex == null" :value="null">개선 계획서 추가 중
                            </b-form-select-option>
                            <b-form-select-option v-for="(action_plan, index) in actionPlans"
                                                  :key="action_plan.id"
                                                  :value="index"
                                                  :disabled="isAddActionPlan"
                            >
                                {{ action_plan_version_name(action_plan, index) }}
                            </b-form-select-option>
                        </b-form-select>
                        <b-btn v-if="!isAddActionPlan" variant="secondary" @click="toggleAddActionPlan">개선계획 추가</b-btn>
                        <b-btn v-else variant="secondary" @click="toggleAddActionPlan">개선계획 추가 취소</b-btn>
                    </div>
                </b-col>
                <b-col cols="12" lg="6">
                    <b-card>
                        <template #header>
                            <h5 class="d-inline-block mr-2 mb-0">전송 내역 및 설정</h5>
                            <template
                                v-if="actionplan_company.action_plan && actionplan_company.action_plan.is_questionnaire_download_block">
                                <b-badge variant="secondary" class="fw-500">
                                    외부 채널 안내 및 발송
                                </b-badge>
                            </template>
                            <template v-else>
                                <b-badge
                                    :variant="currentActionPlan && currentActionPlan.audit_sended_at ? 'primary' : 'danger'"
                                    class="fw-500">
                                    {{ currentActionPlan && currentActionPlan.audit_sended_at ? '발송' : '미발송' }}
                                </b-badge>
                            </template>
                        </template>

                        <template v-if="!currentActionPlan">
                            <b-form @submit.prevent="onSendActionPlan"
                                    @reset="onResetSendContent"
                            >

                                <b-form-group
                                    id="input-group-improvement-external-channel"
                                    label="개선계획서 외부 전송"
                                    label-for="input-improvement-external-channel"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                >
                                    <b-form-checkbox id="improvement-external-channel"
                                                     v-model="audit_side.is_questionnaire_download_block"
                                                     :disabled="is_uploading_questionnaire"
                                                     class="mb-0"
                                                     required
                                    >
                                        개선계획서 외부 전송 여부
                                    </b-form-checkbox>
                                </b-form-group>

                                <b-form-group
                                    id="input-group-improvement-file"
                                    label="개선계획서(개선요구사항)"
                                    label-for="input-improvement-file"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                >
                                    <b-form-file id="input-improvement-file"
                                                 v-model="audit_side.file"
                                                 :disabled="is_uploading_questionnaire || audit_side.is_questionnaire_download_block"
                                                 required
                                    />
                                </b-form-group>

                                <b-form-group
                                    id="input-group-improvement-file-receiver-1"
                                    label="개선계획서 수신인 1"
                                    label-for="input-improvement-file-receiver-1"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                >
                                    <b-form-input id="input-improvement-file-receiver-1" v-model="audit_side.receiver1"
                                                  type="email"
                                                  :disabled="is_uploading_questionnaire || audit_side.is_questionnaire_download_block"
                                                  required
                                    />
                                </b-form-group>

                                <b-form-group
                                    id="input-group-improvement-file-receiver-2"
                                    label="개선계획서 수신인 2"
                                    label-for="input-improvement-file-receiver-2"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    class="mb-0"
                                >
                                    <b-form-input id="input-improvement-file-receiver-2" v-model="audit_side.receiver2"
                                                  type="email"
                                                  :disabled="is_uploading_questionnaire || audit_side.is_questionnaire_download_block"
                                    />
                                </b-form-group>

                                <b-form-row class="d-none">
                                    <b-col cols="12">
                                        <div class="text-right">
                                            <b-btn-group>
                                                <b-btn ref="audit-questionnaire-submit" type="submit" variant="primary">
                                                    {{ !audit_side.is_questionnaire_download_block ? '업로드' : '설정 저장' }}
                                                </b-btn>
                                                <b-btn ref="audit-questionnaire-reset" type="reset" variant="danger">
                                                    취소
                                                </b-btn>
                                            </b-btn-group>
                                        </div>
                                    </b-col>
                                </b-form-row>
                            </b-form>
                        </template>
                        <template v-else>
                            <b-row>
                                <b-col cols="12" class="mb-3">
                                    <div class="d-flex justify-content-between">
                                        <h5 class="pr-2 mb-0">{{
                                                currentActionPlan.is_questionnaire_download_block ? '설정일시' : '발송일시'
                                            }}</h5>
                                        <p class="text-right fw-400 mb-0">
                                            {{ formatDate(currentActionPlan.audit_sended_at) }}</p>
                                    </div>
                                </b-col>
                            </b-row>

                            <template v-if="currentActionPlan.is_questionnaire_download_block">
                                <b-row>
                                    <b-col cols="12" class="mb-0">
                                        <div class="border bgray-200 gray-600 text-center p-3">
                                            <h6 class="font-italic mb-0">외부 채널에서 안내 및 발송</h6>
                                        </div>
                                    </b-col>
                                </b-row>
                            </template>
                            <template v-else>
                                <b-row class="mb-3">
                                    <b-col cols="4">
                                        <h5 class="mb-0">개선계획서</h5>
                                    </b-col>
                                    <b-col cols="8">
                                        <div class="text-right">
                                            <a class="f-90 fw-400 text-decoration-underline mb-0"
                                               style="cursor: pointer;"
                                               @click="downloadActionPlanFile(currentActionPlan.auditor_file_key, currentActionPlan.auditor_filename,  currentActionPlan.auditor_file_ext)"
                                            >
                                                {{
                                                    `${currentActionPlan.auditor_filename}${currentActionPlan.auditor_file_ext}`
                                                }}
                                            </a>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-3">
                                    <b-col cols="4">
                                        <h5 class="mb-0">수신자</h5>
                                    </b-col>
                                    <b-col cols="8">
                                        <div class="fw-400 mb-0 text-right">
                                            <p class="mb-1">{{ currentActionPlan.company_receiver1 }}</p>
                                            <p v-show="currentActionPlan.company_receiver2" class="mb-0">
                                                {{ currentActionPlan.company_receiver2 }}</p>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-0">
                                    <b-col cols="4">
                                        <h5 class="mb-0">다운로드 일시</h5>
                                    </b-col>
                                    <b-col cols="8">
                                        <div class="text-right">
                                            <p class="fw-400 mb-0">
                                                {{
                                                    !currentActionPlan || !currentActionPlan.company_downloaded_at ? ' - ' : formatDate(currentActionPlan.company_downloaded_at)
                                                }}
                                            </p>
                                        </div>
                                    </b-col>
                                </b-row>
                            </template>

                        </template>

                        <!-- <b-row>
                            <b-col cols="12"></b-col>
                        </b-row> -->

                        <template v-if="!currentActionPlan" #footer>
                            <b-form-row>
                                <b-col cols="12">
                                    <div class="text-right">
                                        <b-btn-group>
                                            <b-btn variant="primary"
                                                   :disabled="is_uploading_questionnaire"
                                                   @click="$refs['audit-questionnaire-submit'].click()"
                                            >
                                                <!-- 전송 -->
                                                {{ !audit_side.is_questionnaire_download_block ? '전송' : '저장' }}
                                            </b-btn>
                                            <b-btn variant="danger"
                                                   :disabled="is_uploading_questionnaire"
                                                   @click="$refs['audit-questionnaire-reset'].click()"
                                            >
                                                취소
                                            </b-btn>
                                        </b-btn-group>
                                    </div>
                                </b-col>
                            </b-form-row>
                        </template>
                    </b-card>
                </b-col>
                <b-col cols="12" lg="6">
                    <b-card class="h-100" :body-bg-variant="currentActionPlan?.company_submitter ? 'white' : 'light'">
                        <template #header>
                            <div class="d-flex justify-content-between align-items-end">
                                <div>
                                    <h5 class="d-inline-block mr-2 mb-0">제출 내역</h5>

                                    <template v-if="!currentActionPlan?.company_downloaded_at">
                                        <b-badge variant="danger" class="fw-500">미수신</b-badge>
                                    </template>
                                    <template
                                        v-else-if="currentActionPlan?.company_downloaded_at && !currentActionPlan?.company_submitted_at">
                                        <b-badge variant="success" class="fw-500">작성중</b-badge>
                                    </template>
                                    <template
                                        v-else-if="currentActionPlan?.company_downloaded_at && currentActionPlan?.company_submitted_at">
                                        <b-badge variant="primary" class="fw-500">제출완료</b-badge>
                                    </template>
                                </div>

                                <b-form-checkbox
                                    id="checkbox-company-side-submit-admin"
                                    v-model="company_side.is_admin_submit"
                                    :disabled="!!currentActionPlan?.company_submitter"
                                >
                                    관리자 제출
                                </b-form-checkbox>
                            </div>
                        </template>

                        <!-- company_side.is_admin_submit -->
                        <template v-if="!currentActionPlan?.company_submitter && !company_side.is_admin_submit">
                            <b-row class="h-100" align-v="center" align-h="center">
                                <b-col cols="12">
                                    <div class="text-center"> 제출내역 없음</div>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-else-if="!currentActionPlan?.company_submitter && company_side.is_admin_submit">
                            <b-row>
                                <!-- <b-col cols="12">
                                    <h5 class="mb-0">관리자 개선계획서 대리 제출</h5>
                                </b-col> -->
                                <b-col cols="12">
                                    <b-form-group id="fieldset-input-admin-actionplan-file"
                                                  label="관리자 개선계획서 대리 제출"
                                                  label-for="input-admin-actionplan-file" class="mb-3"
                                                  :disabled="is_submitting_actionplan"
                                    >
                                        <b-form-file id="input-admin-actionplan-file"
                                                     ref="admin-actionplan-file"
                                                     v-model="company_side.file" class="mb-0" browse-text="파일 선택"
                                                     placeholder="제출하실 개선계획서 선택"
                                                     :disabled="is_submitting_actionplan"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <div class="text-right">
                                        <b-btn-group>
                                            <b-btn variant="secondary"
                                                   :disabled="!company_side.file"
                                                   @click="submitComapnyActionPlanByAdmin"
                                            >
                                                제출하기
                                            </b-btn>
                                            <b-btn variant="danger" :disabled="!company_side.file"
                                                   @click="company_side.file = null"
                                            >
                                                초기화
                                            </b-btn>
                                        </b-btn-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                        <template v-else>
                            <b-row class="mb-3">
                                <b-col cols="4">
                                    <h5 class="mb-0">제출자 정보</h5>
                                </b-col>
                                <b-col cols="8">
                                    <div class="d-flex justify-content-end align-items-center">
                                        <template v-if="!currentActionPlan?.company_submitter_id">
                                            <span class="gray-500 font-italic">(미제출)</span>
                                        </template>
                                        <template v-else>
                                            <b-badge class="mr-2">{{
                                                    currentActionPlan?.company_submitter?.id
                                                }}
                                            </b-badge>
                                            <p class="fw-400 mb-0">{{
                                                    currentActionPlan?.company_submitter?.user_name
                                                }}</p>
                                            <br>
                                            <p class="fw-400 mb-0">({{
                                                    currentActionPlan?.company_submitter?.e_mail
                                                }})</p>
                                        </template>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="mb-3">
                                <b-col cols="4">
                                    <h5 class="mb-0">제출 개선계획서</h5>
                                </b-col>
                                <b-col class="8">
                                    <div class="text-right">
                                        <template v-if="!currentActionPlan.company_filename">
                                            <span class="gray-500 font-italic">(미제출)</span>
                                        </template>
                                        <template v-else>
                                            <a class="f-90 fw-400 text-right text-decoration-underline mb-0"
                                               style="cursor: pointer;"
                                               @click="downloadActionPlanFile(currentActionPlan.company_file_key, currentActionPlan.company_filename, currentActionPlan.company_file_ext)"
                                            >
                                                {{
                                                    `${currentActionPlan.company_filename}${currentActionPlan.company_file_ext}`
                                                }}
                                            </a>
                                        </template>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <h5 class="mb-0">제출일시</h5>
                                </b-col>
                                <b-col cols="8">
                                    <div class="text-right">
                                        <template v-if="!currentActionPlan?.company_submitted_at">
                                            <span class="gray-500 font-italic">(미제출)</span>
                                        </template>
                                        <template v-else>
                                            <p class="fw-400 mb-0">
                                                {{ formatDate(currentActionPlan?.company_submitted_at) || '미제출' }}</p>
                                        </template>
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import axios from 'axios';
import downloadFile from '@shared_mixins/downloadFile';
import initializeDataProgress from '@shared_mixins/contractor-dashboard/initialize-data-progress';
import {mapState} from 'vuex';
import dayjs from 'dayjs';

export default {
    name: 'ManagingImprovements',
    props: {
        actionplan_company: {
            type: Object,
            default: null
        }
    },
    mixins: [
        initializeDataProgress,
        downloadFile
    ],
    data() {
        return {
            is_uploading_questionnaire: false,
            is_submitting_actionplan: false,
            audit_side: {
                receiver1: null,
                receiver2: null,
                file: null,
                is_questionnaire_download_block: false
            },
            selectedActionPlanIndex: null,
            isAddActionPlan: false,
            company_side: {
                sender: null,
                file: null,
                is_admin_submit: false
            }
        };
    },
    computed: {
        ...mapState(['user_id']),
        file_prefix_url() {
            return `https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/`;
        },
        actionPlans() {
            return this.actionplan_company?.action_plan || [];
        },
        currentActionPlan() {
            return this.selectedActionPlanIndex !== null
                ? this.actionplan_company.action_plan[this.selectedActionPlanIndex]
                : null;
        },
        action_plan_version_name() {
            return (action_plan, index) => {
                return `v${this.actionPlans.length - index} - ${dayjs(action_plan?.created_at).format('YYYY-MM-DD HH:mm:ss')}`;
            };
        }
    },
    created() {
        this.initForm();
        this.initData();
    },
    beforeDestroy() {
        this.initForm();
    },
    methods: {
        toggleAddActionPlan() {
            this.isAddActionPlan = !this.isAddActionPlan;
            if (this.isAddActionPlan) {
                this.selectedActionPlanIndex = null;
            } else {
                this.selectedActionPlanIndex = 0;
            }
            this.initForm();
        },
        initForm() {
            this.audit_side = {receiver1: null, receiver2: null, file: null};
            this.company_side = {sender: null, file: null, is_admin_submit: false};
        },
        initData() {
            if (this.actionplan_company) {
                this.actionplan_company?.action_plan?.sort((a, b) => {
                    return new Date(b.created_at) - new Date(a.created_at);
                });
                if (this.actionplan_company?.action_plan.length > 0) {
                    this.selectedActionPlanIndex = 0;
                }
            }
        },
        async downloadActionPlanFile(file_key, file_name, file_exp) {
            const _res_audit_action_plan = await axios.get(`${this.file_prefix_url}${file_key}`, {
                responseType: 'blob'
            });

            this.downloadFileFromResponse(_res_audit_action_plan, file_name, file_exp);
        },
        async onSendActionPlan() {
            let is_done = false;
            try {
                if (this.audit_side.is_questionnaire_download_block) {
                    this.is_uploading_questionnaire = true;
                    if (confirm('개선계획서 외부 전송 체크시 기업 평가 담당자가 내부 시스템에서 개선계획서를 다운로드 할 수 없습니다. 저장하시겠습니까?')) {
                        const _res_block_qustionnaire = await this.$axios.post('/actionplans/questionnaire/block', {
                            request_id: this.actionplan_company.request_id,
                            auditor_id: this.user_id,
                            is_block_questionnaire_download: this.audit_side.is_questionnaire_download_block
                        });

                        this.$emit('update-actionplan', _res_block_qustionnaire.data);
                        is_done = true;
                    }
                } else {
                    if (confirm('개선계획 파일을 전송할 시 기업 담당자에게 자동으로 알림 메일이 전송됩니다. 정말로 업로드 하시겠습니까?')) {
                        this.is_uploading_questionnaire = true;
                        const questionnaire_form = new FormData();
                        questionnaire_form.append('request_id', this.actionplan_company.request_id);
                        questionnaire_form.append('auditor_id', this.user_id);
                        questionnaire_form.append('questionnaire_receiver_1', this.audit_side.receiver1);
                        if (this.audit_side.receiver2) {
                            questionnaire_form.append('questionnaire_receiver_2', this.audit_side.receiver2);
                        }
                        questionnaire_form.append('questionnaire', this.audit_side.file);

                        const _res_save_questionnaire = await this.$axios.post('/actionplans/questionnaire', questionnaire_form);
                        this.$emit('update-actionplan', _res_save_questionnaire.data);
                        is_done = true;
                    }
                }
                // 확인창에서 취소하면 전송 완료 안내와 모달 닫기를 하지 않고 입력값을 유지한다
                if (is_done) {
                    this.$EventBus.$emit('toast-success', this.$t('개선계획서 전송'), this.$t('개선계획서가 성공적으로 전송되었습니다.'));
                    this.$bvModal.hide('improvement-management-modal');
                }

            } catch (error) {
                if (error.response) {
                    const {status} = error.response;
                    const data = getErrorMessage(error, '');
                    if (status === 400 && data === 'Empty_Questionnaire_Contents') {
                        alert('빈 개선계획서 파일을 업로드 하셨습니다. 파일을 확인해주세요.');
                        return false;
                    }
                }

                alert('죄송합니다. 개선계획서 업로드 및 발신 도중 장애가 발생했습니다. 개발팀에 문의해주세요.');

                this.audit_side.file = null;
            } finally {
                this.is_uploading_questionnaire = false;
            }
        },
        onResetSendContent() {
            this.audit_side = {receiver1: null, receiver2: null, file: null};
            this.is_uploading_questionnaire = false;
        },
        async submitComapnyActionPlanByAdmin() {
            try {
                this.is_submitting_actionplan = true;
                const is_confirmed_submit_actionplan = confirm('개선계획서를 제출하시겠습니까?');
                if (is_confirmed_submit_actionplan) {
                    const _acitonplan_form = new FormData();
                    _acitonplan_form.append('request_id', this.actionplan_company.request_id);
                    _acitonplan_form.append('submitter_id', this.user_id);
                    _acitonplan_form.append('company_actionplan', this.company_side.file);
                    _acitonplan_form.append('actionplan_id', this.currentActionPlan.id);

                    const _res_sumbit_actionplan = await this.$axios.post('/actionplans/submit', _acitonplan_form, {
                        headers: {
                            contentType: 'multipart/form-data'
                        }
                    });

                    this.$emit('update-actionplan', _res_sumbit_actionplan.data);

                    this.$EventBus.$emit('toast-success', this.$t('개선계획서 전송'), this.$t('개선계획서가 성공적으로 전송되었습니다.'));
                    this.$bvModal.hide('improvement-management-modal');
                }
            } catch (error) {
                if (error.response) {
                    const {status} = error.response;
                    const data = getErrorMessage(error, '');
                    if (status === 400 && data === 'Empty_Questionnaire_Contents') {
                        alert('빈 개선계획서 파일을 업로드 하셨습니다. 파일을 확인해주세요.');
                    } else if (status === 404 && data === 'Not_Found_Request') {
                        alert('죄송합니다. 개선계획서 제출 도중 장애가 발생했습니다. QESG에 문의해주시기 바랍니다.');
                    } else {
                        alert('죄송합니다. 개선계획서 업로드 중 장애가 발생했습니다. 개발팀에 문의해주세요.');
                    }
                } else {
                    alert('죄송합니다. 개선계획서 업로드 중 장애가 발생했습니다. 개발팀에 문의해주세요.');
                }

                this.company_side.file = null;
            } finally {
                this.is_submitting_actionplan = false;
            }
        }
    }
};
</script>
